function getUri() {
    var uri = config.uri,
        char = '?';

    if (uri.indexOf('?') != -1) {
        char = '&';
    }

    return config.domain + "/" + uri + char;
}

function refresh(urlSegments) {

    setLoading('body');

    $.get(getUri() + urlSegments.join(''), function (data) {

        let html = $('<div>').append(data);

        if (html.find('#page').hasClass('vacancies') &&
            html.find('#categories').length > 0) {
            $('#categories').html(html.find('#categories').html());
        }

        if (html.find('#page').hasClass('events') &&
            html.find('#charities').length > 0) {
            $('#charities').html(html.find('#charities').html());
        }

        $('.filters').html(html.find('.filters').html());
        if ($('.counting').length > 0) {
            $('.counting span.singular-or-plural').html(html.find('.counting span.singular-or-plural').html() + ' ');
        }
        if ($('.counting-mobile').length > 0) {
            $('.counting-mobile span.singular-or-plural').html(html.find('.counting-mobile span.singular-or-plural').html() + ' ');
        }
        $('.list-container').html(html.find('.list-container').html());

        setLoading('body', 'remove');

        window.scrollTo({ 
            top: 0, 
            behavior: 'smooth' 
        });
    });
}

$(document).ready(function () {

    //click (mobile) categories (collapsing)
    $(document).on('click', '.categories > div', function() {

        if ($(window).width() <= 992) {
            let list = $(this).parent().find('ul');

            list.slideToggle(function() {
                list.toggleClass('show');
            });

            $(this).toggleClass('collapsed'); 
        }
    });

    //sorting
    $(document).on('change', '#result-sorting', function () {

        var urlSegments = [];
        urlSegments.push('filterxhr=true');
        urlSegments.push('&sort=' + $(this).val().replace(' ', '_'));
        if ($('.search-block input').length > 0) {
            urlSegments.push('&search=' + encodeURI($('.search-block input').val()));
        }
        if ($('.search input').length > 0) {
            urlSegments.push('&search=' + encodeURI($('.search input').val()));
        }
        
        refresh(urlSegments);
    });

    $(document).on('click', '#result-sorting-pills div', function () {

        $('.pill').removeClass('selected');
        $(this).addClass('selected');

        var urlSegments = [];
        urlSegments.push('filterxhr=true');
        urlSegments.push('&sort=' + $(this).data('value').replace(' ', '_'));
        if ($('.search-block input').length > 0) {
            urlSegments.push('&search=' + encodeURI($('.search-block input').val()));
        }
        if ($('.search input').length > 0) {
            urlSegments.push('&search=' + encodeURI($('.search input').val()));
        }

        refresh(urlSegments);
    });

    //open/close an filter
    $(document).on('click', '.filters .title', function (e) {

        e.preventDefault();

        let values = $(this).closest('.group').find('.values');

        $(this).toggleClass('collapsed');

        var urlSegments = [];
        urlSegments.push('filterxhr=true');
        urlSegments.push('&action=true');
        urlSegments.push('&prefix='+$('.filters').data('prefix'));
        urlSegments.push('&filter='+$(this).closest('.group').data('filter-id'));
        urlSegments.push('&show='+(values.hasClass('show')
            ? '0'
            : '1'));
 
        values.slideToggle(function() {
            values.toggleClass('show');
        });

        $.ajax({
            url: config.domain + '/frontend/functions/set_filters.php'+urlSegments.join(''),
            type: 'GET'
        });
    });

    //check an filter value
    $(document).on('click', '.filters input[type=checkbox]', function () {

        var values = [];
        $.each($(this).closest('.group').find("input:checked"), function () {
            values.push($(this).val());
        });

        var urlSegments = [];
        urlSegments.push('filterxhr=true');
        urlSegments.push('&filter=' + $(this).closest('.group').data('filter-id'));
        urlSegments.push('&values=' + values.join(','));

        if ($('.search-block input').length > 0) {
            urlSegments.push('&search='+encodeURI($('.search-block input').val()));
        }

        if ($('.search input').length > 0) {
            urlSegments.push('&search='+encodeURI($('.search input').val()));
        }

        refresh(urlSegments);
    });

    //search 
    $(document).on('click', '.btn-product-search, .input-group-text', function (e) {

        e.stopPropagation();

        var urlSegments = [];
        urlSegments.push('filterxhr=true');
        urlSegments.push("&search="+encodeURI($(this).closest('.input-group').find('input').val()));
        refresh(urlSegments);
    });

    let searchTimer;
    $('.search-block input').on('keydown', function (e) {
        clearTimeout(searchTimer);
        searchTimer = null;
    });

    $('.search-block input').on('keyup', function (e) {

        e.stopPropagation();

        let self = $(this);

        searchTimer = setTimeout(function () {
            let value = self.closest('.input-group').find('input').val();

            let noWhitespaceValue = value.replace(/\s+/g, '');
            let noWhitespaceCount = noWhitespaceValue.length;

            if (noWhitespaceCount >= 3 || value == '') {

                var urlSegments = [];
                urlSegments.push("search=" + encodeURI(value));
                refresh(urlSegments);

            }
        }, 2000);
    });

    //resetting all filters
    $(document).on('click', '.btn-filters-reset', function () {
        
        var urlSegments = [];
        urlSegments.push('filterxhr=true');
        urlSegments.push('&reset=1');
        if ($('.search-block input').length > 0) {
            urlSegments.push('&search='+encodeURI($('.search-block input').val()));
        }
        if ($('.search input').length > 0) {
            urlSegments.push('&search='+encodeURI($('.search input').val()));
        }
        refresh(urlSegments);
    });

    //Opens/closes products filters mobile menu
    $('body').on('click', [
        '.filters-mobile-toggle button',
        '.category-pills button',
        '.btn-close-filter',
        '.filters-show-results',
        '.filter-gradient'
    ].join(', ') ,function() {

        
        if ($('body').hasClass('filters-mobile-open')) {

            if ($('.search-block').length > 0) {
                setTimeout(function() {
                    $('.page-aside .search-block').clone().insertAfter($('.page-aside .categories'));
                    $('.page-aside > .search-block').remove();

                    $('body').toggleClass('filters-mobile-open-after');
                }, 450);
            }
            if ($('.search').length > 0) {
                setTimeout(function() {
                    $('.page-aside .search').clone().insertAfter($('.page-aside .categories'));
                    $('.page-aside > .search').remove();

                    $('body').toggleClass('filters-mobile-open-after');
                }, 450);
            }

        } else {
            
            if ($('.search-block').length > 0) {
                $('.page-aside .mobile .search-block').clone().insertBefore(".filter-results");
                $('.page-aside .mobile .search-block').remove();
            }
            if ($('.search').length > 0) {
                $('.page-aside .mobile .search').clone().insertBefore(".filter-results");
                $('.page-aside .mobile .search').remove();
            }

            setTimeout(function() {
                $('body').toggleClass('filters-mobile-open-after');
            }, 450);
        }

        $('body').toggleClass('filters-mobile-open');
        setOverlay('header', 'filter');
    });


    
    $(document).on('click', '.pagination li', function (e) {
        e.preventDefault();

        var urlSegments = [];
        urlSegments.push('filterxhr=true');
        urlSegments.push("&page=" + $(this).data('page'));
        if ($('.search-filter input').length > 0) {
            urlSegments.push('&search=' + encodeURI($('.search-filter input').val()));
        }
        refresh(urlSegments);
    });

    $(document).on('click', '.btn-open-read-more', function (e) {

        $('body').append('<div class="read-more row">' +
            '<div class="col-12 head">' + $(this).data('title') + '<i class="fas fa-times close-read-more"></i></div>' +
            '<div class="col-12 content">' + $(this).data('content') + '</div>' +
            '</div>');


        if (!$('.read-more').hasClass('open')) {

            $('.read-more').animate({
                "left": "16px"
            }, 100, function () {

                $('body').append('<div class="read-more-gradient"></div>');
            }).addClass('open');
        }
    })
    $(document).ready(function(){
        $(".showMoreSpecialities").click(function(){
            $('.filterValue').removeClass('d-none');
            $('.showMoreSpecialities').removeClass('d-lg-block');
            $('.showMoreSpecialities').addClass('d-none');
            $('.showLessSpecialities').addClass('d-lg-block');
            $('.showLessSpecialities').removeClass('d-none');
        });
    });
    $(document).ready(function(){
        $(".showLessSpecialities").click(function(){
            $('.filterValue').addClass('d-none');
            $('.showLessSpecialities').removeClass('d-lg-block');
            $('.showLessSpecialities').addClass('d-none');
            $('.showMoreSpecialities').addClass('d-lg-block');
            $('.showMoreSpecialities').removeClass('d-none');
        });
    });
    $(document).on('click', '.close-read-more, .read-more-gradient', function () {

        $('.read-more-gradient').remove();
        if ($('.read-more').hasClass('open')) {

            $('.read-more').animate({
                "left": "-1000px"
            }, 500, function () {

                $('.read-more').remove();

            }).removeClass('open');
        }
    })

    // $(document).on('change', '.products_overview_limiter', function () {
    //     setLoading('.loading-target');

    //     var urlSegments = [];
    //     urlSegments.push("limiter=" + $(this).val());
    //     urlSegments.push('&search=' + encodeURI($('.product-search').closest('.input-group').find('input').val()));
    //     refresh(urlSegments);
    // });
});